/* eslint-disable unicorn/prefer-top-level-await */
import { z } from 'zod'
import { catchWithSentryCapture } from '../utils'

const relevanceSchema = z.enum(['low', 'medium', 'high', 'none'])

export const relevancesSchema = z
  .union([z.array(relevanceSchema), relevanceSchema.transform((v) => [v])])
  .optional()
  .default([])
  .catch(catchWithSentryCapture([], 'relevancesSchema'))
export type RelevancesQueryParameters = z.infer<typeof relevancesSchema>
